import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Search, X } from 'lucide-react';

const JOURNEY_LABELS = {
  SAME_LIMIT_RENEWAL: 'Same Limit Renewal',
  ENHANCED_LIMIT: 'Enhanced Limit',
  NEW_FARMER: 'New Farmer',
};

const DATE_RANGES = [
  { value: 'all', label: 'All' },
  { value: 'today', label: 'Today' },
  { value: '7d', label: 'Last 7 days' },
  { value: '30d', label: 'Last 30 days' },
];

const InboxFilterBar = ({ districts = [], filters, onChange, onClear, tab }) => {
  const handleChange = (key, value) => {
    onChange({ ...filters, [key]: value === 'all' ? null : value });
  };

  const activeCount = Object.values(filters).filter(v => v && v !== 'all').length;

  return (
    <div className="flex flex-wrap items-center gap-2 mb-4 p-3 bg-white border border-gray-200 rounded-md" data-testid="inbox-filter-bar">
      <div className="relative flex-1 min-w-[220px]">
        <Search className="absolute left-2.5 top-2.5 h-3.5 w-3.5 text-gray-400" />
        <Input
          className="h-9 text-sm pl-8"
          placeholder="Search by farmer name or Aadhaar last 4..."
          value={filters.q || ''}
          onChange={e => handleChange('q', e.target.value)}
          data-testid="inbox-search-input"
        />
      </div>

      <select
        className="h-9 text-sm border border-gray-300 rounded-md px-2 bg-white min-w-[140px]"
        value={filters.district || 'all'}
        onChange={e => handleChange('district', e.target.value)}
        data-testid="inbox-filter-district"
      >
        <option value="all">All Districts</option>
        {districts.map(d => <option key={d} value={d}>{d}</option>)}
      </select>

      <select
        className="h-9 text-sm border border-gray-300 rounded-md px-2 bg-white min-w-[160px]"
        value={filters.journey_type || 'all'}
        onChange={e => handleChange('journey_type', e.target.value)}
        data-testid="inbox-filter-journey"
      >
        <option value="all">All Journeys</option>
        {Object.entries(JOURNEY_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
      </select>

      {tab === 'recently_decided' && (
        <select
          className="h-9 text-sm border border-gray-300 rounded-md px-2 bg-white min-w-[140px]"
          value={filters.status || 'all'}
          onChange={e => handleChange('status', e.target.value)}
          data-testid="inbox-filter-status"
        >
          <option value="all">All Decisions</option>
          <option value="APPROVED">Approved</option>
          <option value="REJECTED">Rejected</option>
          <option value="RETURNED">Returned</option>
        </select>
      )}

      <select
        className="h-9 text-sm border border-gray-300 rounded-md px-2 bg-white min-w-[120px]"
        value={filters.date_range || 'all'}
        onChange={e => handleChange('date_range', e.target.value)}
        data-testid="inbox-filter-date-range"
      >
        {DATE_RANGES.map(d => <option key={d.value} value={d.value}>{d.label}</option>)}
      </select>

      {activeCount > 0 && (
        <Button
          variant="ghost"
          size="sm"
          className="h-9 text-xs text-gray-500 hover:text-gray-800"
          onClick={onClear}
          data-testid="inbox-clear-filters-btn"
        >
          <X className="h-3 w-3 mr-1" /> Clear ({activeCount})
        </Button>
      )}
    </div>
  );
};

export default InboxFilterBar;
